// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-card{position:relative;display:flex;flex-direction:column;border-radius:.25rem;background-color:#fff;box-shadow:0 25px 50px rgba(8,21,66,.06);-webkit-background-clip:border;-moz-background-clip:border;background-clip:border-box;margin-bottom:30px}.ui-card:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
